/** Reserve the tab during the click so a slow PDF request cannot lose user activation. */
export function openPdfWindow(title: string, autoPrint: boolean) {
  const handle = window.open('about:blank', '_blank')
  if (!handle) throw new Error('Popup blocked. Allow popups to print the entrant packet.')

  let url: string | undefined
  let closedTimer: number | undefined
  const release = () => {
    if (closedTimer !== undefined) window.clearInterval(closedTimer)
    if (url) URL.revokeObjectURL(url)
    closedTimer = undefined
    url = undefined
  }
  const close = () => {
    release()
    handle.close()
  }

  try {
    // Passing noopener to open() also returns null for successfully opened tabs.
    // Detach the blank tab before placing any document content in it instead.
    handle.opener = null
    handle.document.title = title
  } catch (error) {
    close()
    throw error
  }

  return {
    close,
    show(buffer: ArrayBuffer) {
      if (handle.closed)
        throw new Error('The packet tab was closed. Select Print Packet to try again.')
      try {
        url = URL.createObjectURL(new Blob([buffer], { type: 'application/pdf' }))
        if (autoPrint) {
          handle.addEventListener(
            'load',
            () => {
              try {
                handle.focus()
                handle.print()
              } catch {
                // The PDF viewer remains available when automatic printing is unsupported.
              }
            },
            { once: true }
          )
        }
        handle.location.replace(url)
        // Keep the URL usable for the PDF viewer and Save/Print for as long as
        // the tab is open. beforeunload on about:blank would revoke it too soon.
        closedTimer = window.setInterval(() => {
          if (handle.closed) release()
        }, 1000)
      } catch (error) {
        close()
        throw error
      }
    },
  }
}
